import { StylesGroup } from '../../../types';
import { CompRef } from '@wix/document-services-types';
import { VirtualManifestAPI } from '@wix/editor-platform-manifest-services';
import type { EditorPointer } from '@wix/editor-document-logic-api';

const getChildrenEditorPointers = (
  context: VirtualManifestAPI,
  editorPointers: EditorPointer<CompRef>[] = [],
): EditorPointer<CompRef>[] => {
  const children = context.getChildren();

  children.forEach((child) => {
    editorPointers.push(child.getEditorPointer());
    getChildrenEditorPointers(child, editorPointers);
  });

  return editorPointers;
};

type RootContextInfo = {
  rootGroups: StylesGroup[];
  context: VirtualManifestAPI;
  childGroups: StylesGroup[];
};

export const buildRootContextInfosMap = (
  groups: StylesGroup[],
  rootContexts: VirtualManifestAPI[],
): Record<string, RootContextInfo> => {
  const rootEditorPointerUniqueKeys = rootContexts.map(
    (context) => context.getEditorPointer().asUniqueKey,
  );
  const groupContextsInfo: Record<string, RootContextInfo> = {};
  const childrenPointerToContextInfoMap: Record<string, RootContextInfo> = {};

  for (const rootContext of rootContexts) {
    const uniqueKey = rootContext.getEditorPointer().asUniqueKey;
    groupContextsInfo[uniqueKey] = {
      context: rootContext,
      rootGroups: [],
      childGroups: [],
    };

    getChildrenEditorPointers(rootContext).forEach((childPointer) => {
      const childUniqueKey = childPointer.asUniqueKey;
      childrenPointerToContextInfoMap[childUniqueKey] =
        groupContextsInfo[uniqueKey];
    });
  }

  for (const group of groups) {
    const groupUniqueKey = group.editorPointer.asUniqueKey;

    if (childrenPointerToContextInfoMap[groupUniqueKey]) {
      childrenPointerToContextInfoMap[groupUniqueKey].childGroups.push(group);
      continue;
    }

    const isRootGroup = rootEditorPointerUniqueKeys.includes(groupUniqueKey);

    if (isRootGroup) {
      groupContextsInfo[groupUniqueKey].rootGroups.push(group);
    }
  }

  return groupContextsInfo;
};
